<template>
  <v-card
    :class="{teachingFocus: $store.state.guide.stepName === 'CanPack'}"
    class="CanPackTeachingTarget"
  >
    <v-layout
      class="mx-0 grey pl-3 lighten-3"
      align-center
      style="height: 48px;"
    >
      <img
        v-if="!$store.state.userData.settings || $store.state.edition !== 's'"
        src="../images/nengjima.png"
        height="22"
        class="mr-2"
      >
      <img
        v-else
        height="22"
        src="../images/nengjima-s.svg"
        class="mr-2"
      >
      能寄嗎
      <v-spacer />
    </v-layout>
    <v-divider />
    <div
      class="contentTop"
    >
      <div class="px-2 pb-2">
        <v-text-field
          v-model="searchKey"
          :loading="searchLoading"
          placeholder="輸入商品關鍵詞或黏貼商品標題"
          append-icon="search"
          class="mt-0"
          hide-details
          clearable
          @keyup.enter="onSearchKeyEnter"
          @click:clear="resetSearch"
        >
          <template #append>
            <v-btn
              class="mx-2"
              fab
              depressed
              x-small
              color="orange white--text"
              style="height: 25px;width: 25px;margin: 0;"
              @click="searchByKeyword()"
            >
              <v-icon>
                search
              </v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </div>
    </div>

    <div
      v-if="tpCatError.name === 'unknownCat'"
      class="text-xs-center pa-2"
    >
      <div v-html="tpCatError.message" />
    </div>
    <div
      v-else-if="tpCatError && typeof tpCatError === 'string'"
      class="text-xs-center red--text pa-2"
    >
      {{ tpCatError }}
    </div>
    <div
      v-else-if="shouldShowError"
      class="text-xs-center red--text pa-2"
    >
      {{ searchError }}
    </div>
    <div
      v-if="loadingTpCat"
      class="text-xs-center pa-2"
    >
      客服正在查詢……{{ searchTimer }}
    </div>
    <div v-else-if="taobaoData">
      <div class="title text-xs-center my-4">
        「{{ tpCatalog.catTwName }}」
      </div>
      <div v-if="taobaoData?.item">
        <v-divider />
        <CanpackGoodsItem
          :goods="taobaoData?.item"
        />
      </div>
      <v-divider />
      <div
        v-if="firstQa"
        :class="{dark: $vuetify.theme.dark}"
        class="qaWrap pa-4"
      >
        <div class="py-2 text-body-1">
          {{ firstQa.qaTitle }}
        </div>
        <v-layout align-center>
          <v-radio-group
            v-model="answer"
            row
            hide-details
            class="mt-0 pt-0"
          >
            <template v-if="firstQa.qaRadioB.text === '是'">
              <v-radio
                :label="firstQa.qaRadioB.text"
                value="qaRadioB"
              />
              <v-radio
                :label="firstQa.qaRadioA.text"
                value="qaRadioA"
              />
            </template>
            <template v-else>
              <v-radio
                :label="firstQa.qaRadioA.text"
                value="qaRadioA"
              />
              <v-radio
                :label="firstQa.qaRadioB.text"
                value="qaRadioB"
              />
            </template>
          </v-radio-group>
          <v-btn
            :disabled="!answer"
            :color="$vuetify.theme.dark?'info':'blue--text'"
            small
            class="ml-4"
            @click="submitAnswer"
          >
            提交
          </v-btn>
        </v-layout>
      </div>
      <template v-else>
        <div class="px-2">
          <div class="subTitle py-2">
            運輸方式
          </div>
          <v-divider />
          <v-layout
            row
            wrap
            class="ma-0 my-2"
          >
            <!-- <v-flex
              v-if="tpCatalog.catEmbargoAir === '1' || hasCcBan"
              xs12>
              <SrIcon
                transport="air"
                class="mr-1"
              />
              <span style="display: inline-block;width: 70px">空運</span>
              <span
                class="red--text">
                禁運<i
                  class="iconfont iconerror ml-1"/>
              </span>
            </v-flex> -->
            <v-flex
              v-if="!isFurniture && hasCcBan"
              xs12
            >
              <SrIcon
                transport="air"
                class="mr-1"
              />
              <span style="display: inline-block;width: 80px">空運</span>
              <span
                class="red--text"
              >
                禁運<i
                  class="iconfont iconerror ml-1"
                />
              </span>
            </v-flex>
            <v-flex
              v-else-if="!isFurniture && tpCatalog.catSrType !== 'twt'"
              xs12
            >
              <SrIcon
                transport="air"
                class="mr-1"
              />
              <span style="display: inline-block;width: 80px">深圳倉空運</span>
              <span
                v-if="tpCatalog.catEmbargoAir === '0' && tpCatalog.catSrType !== 'twt'"
                class="green--text"
              >
                允許<i
                  class="iconfont iconzhengque ml-1"
                />
              </span>
              <span
                v-else
                class="red--text"
              >
                禁運<i
                  class="iconfont iconerror ml-1"
                />
              </span>
            </v-flex>
            <v-flex
              v-else-if="!isFurniture"
              xs12
            >
              <SrIcon
                transport="air"
                srType="twt"
                class="mr-1"
              />
              <span style="display: inline-block;width: 80px">深圳倉空運</span>
              <span
                v-if="tpCatalog.catEmbargoAir === '0'"
                class="green--text"
              >
                允許<i
                  class="iconfont iconzhengque ml-1"
                />
              </span>
              <span
                v-else
                class="red--text"
              >
                禁運<i
                  class="iconfont iconerror ml-1"
                />
              </span>
            </v-flex>
            <v-flex
              v-if="!isFurniture"
              xs12
            >
              <SrIcon
                transport="se"
                class="mr-1"
              />
              <span style="display: inline-block;width: 80px">海快</span>
              <span
                v-if="tpCatalog.catEmbargoSe === '0' && !hasCcBan"
                class="green--text"
              >
                允許<i
                  class="iconfont iconzhengque ml-1"
                />
              </span>
              <span
                v-else
                class="red--text"
              >
                禁運<i
                  class="iconfont iconerror ml-1"
                />
              </span>
            </v-flex>
            <template v-else>
              <v-flex
                xs12
              >
                <SrIcon
                  transport="se"
                  class="mr-1"
                />
                <span style="display: inline-block;width: 80px">海快家具</span>
                <span
                  v-if="tpCatalog.catEmbargoSe === '0' && !hasCcBan"
                  class="green--text"
                >
                  允許<i
                    class="iconfont iconzhengque ml-1"
                  />
                </span>
                <span
                  v-else
                  class="red--text"
                >
                  禁運<i
                    class="iconfont iconerror ml-1"
                  />
                </span>
                <span class="red--text ml-1">漳州倉</span>
              </v-flex>
              <v-flex
                xs12
              >
                <SrIcon
                  transport="sea"
                  class="mr-1"
                />
                <span style="display: inline-block;width: 80px">海運家具</span>
                <span
                  v-if="!hasCcBan"
                  class="green--text"
                >
                  允許<i
                    class="iconfont iconzhengque ml-1"
                  />
                </span>
                <span
                  v-else
                  class="red--text"
                >
                  禁運<i
                    class="iconfont iconerror ml-1"
                  />
                </span>
                <span class="red--text ml-1">漳州倉</span>
              </v-flex>
            </template>
            <!-- <v-flex
              xs12>
              <SrIcon
                transport="sea"
                class="mr-1"
              />
              <span style="display: inline-block;width: 80px">海運(家具)</span>
              <span
                v-if="tpCatalog.catMold === '4' && !hasCcBan"
                class="green--text">
                允許<i
                  class="iconfont iconzhengque ml-1"/>
              </span>
              <span
                v-else
                class="red--text">
                禁運<i
                  class="iconfont iconerror ml-1"/>
              </span>
            </v-flex> -->
          </v-layout>
        </div>
        <v-divider />
        <div class="px-2">
          <template v-if="!hasCcBan">
            <template v-if="tpCatalog.catInclTaxMaxWt !== '999999' && tpCatalog.catEmbargoSe === '0'">
              <div class="subTitle flex-grow-1 py-2">
                全包稅限制
              </div>
              <v-divider class="mb-2" />
              <div
                class="orange--text pb-2"
              >
                <template v-if="tpCatalog.catInclTaxMaxWt>0">
                  此類型商品單筆集運{{ tpCatalog.catInclTaxMaxWt | toKg }}公斤以上不列入全包稅範圍
                  <span v-if="tpCatalog.catInclTaxMaxWt>=10000">，建議請賣家使用紙箱包裝，有機會避免海關查驗調稅。</span>
                </template>
                <template v-else>
                  此商品不包稅
                </template>
              </div>
            </template>
            <template v-if="tpCatalog.catMold == '2'">
              <div class="subTitle flex-grow-1 py-2">
                食品下單限制
              </div>
              <v-divider class="mb-2" />
              <div
                class="orange--text pb-2"
              >
                食品類包裹只能與食品類包裹合併下單，無法與非食品包裹合併下單。
              </div>
            </template>
            <template v-if="tpCatalog.catMold == '5'">
              <div class="subTitle flex-grow-1 py-2">
                大型易碎品提醒
              </div>
              <v-divider class="mb-2" />
              <div
                class="orange--text pb-2"
              >
                大型易碎品在碼頭裝卸過程中極容易損壞，因此巧巧郎不承運單邊超過50公分的易碎品，若堅持打包回臺巧巧郎不承擔運輸損失。
              </div>
            </template>
            <template v-if="tpCatalog.catCcMaxWt !== '999999'">
              <div class="subTitle flex-grow-1 py-2">
                進口重量限制
              </div>
              <v-divider class="mb-2" />
              <div
                class="red--text pb-2"
              >
                建議您單次航班裡同商品重量不要超過{{ tpCatalog.catMold == '2'?5000:tpCatalog.catCcMaxWt| toKg }}KG，以免需要額外的輸入許可證而影響通關。
              </div>
            </template>
            <template v-if="tpCatalog.catCcMaxBox !== '999'">
              <div class="subTitle flex-grow-1 py-2">
                進口箱數限制
              </div>
              <v-divider class="mb-2" />
              <div
                class="red--text pb-2"
              >
                建議您單次航班裡同商品數量不要超過{{ tpCatalog.catCcMaxBox }}箱，以免需要額外的輸入許可證而影響通關。
              </div>
            </template>
            <template v-if="tpCatalog.catCcMaxQty !== '999999'">
              <div class="subTitle flex-grow-1 py-2">
                進口數量限制
              </div>
              <v-divider class="mb-2" />
              <div
                class="red--text pb-2"
              >
                建議您單次航班進口此商品不要超過{{ tpCatalog.catCcMaxQty }}件，以免需要額外的輸入許可證而影響通關。
              </div>
            </template>
            <template v-if="tpCatalog.catMold == '3'">
              <div class="subTitle flex-grow-1 py-2">
                液體進口限制
              </div>
              <v-divider class="mb-2" />
              <div
                class="red--text pb-2"
              >
                桶裝液體商品、單個包裹超過5KG的液體商品因運送過程易破損，無法提供集運服務。
              </div>
            </template>
          </template>
          <template v-if="tpCatalog.catShptBrief">
            <div class="subTitle flex-grow-1 py-2">
              進口限制
            </div>
            <v-divider class="mb-2" />
            <div
              class="red--text pb-2"
            >
              {{ tpCatalog.catShptBrief }}
            </div>
          </template>
          <template v-if="shangjian">
            <div
              v-if="tpCatalog.trfExemptAmt>0||tpCatalog.trfExemptQty>0"
              class="subTitle flex-grow-1 py-2"
            >
              商檢貨有免證條件
            </div>
            <div
              v-else
              class="subTitle flex-grow-1 py-2"
            >
              商檢貨無免證條件
            </div>
            <v-divider class="mb-2" />
            <div
              class="red--text pb-2"
            >
              <div v-if="tpCatalog.trfExemptAmt>0||tpCatalog.trfExemptQty>0">
                屬於經濟部標準檢驗局公告應施進口檢驗商品。批量進貨需要G1正式報關並需要商檢。巧巧郎可免費協助辦理商檢。<br>
                個人申報進口單次不超過{{ tpCatalog.trfExemptAmt }}元<span v-if="tpCatalog.trfExemptQty>0">且數量不超過{{ tpCatalog.trfExemptQty }}個</span>可免於商檢。<br>
                公司申報進口必須商檢。<br>
              </div>
              <div v-else>
                屬於經濟部標準檢驗局公告應施進口檢驗商品。批量進貨需要G1正式報關並需要商檢。巧巧郎可免費協助辦理商檢。
              </div>
            </div>
          </template>
          <template v-if="huowushui">
            <div class="subTitle flex-grow-1 py-2">
              貨物稅
            </div>
            <v-divider class="mb-2" />
            <div
              class="red--text pb-2"
            >
              屬於稽徵特別規定之商品，批量進口應課徵貨物稅並G1正式報關。
            </div>
          </template>
          <template v-if="fqxs">
            <div class="subTitle flex-grow-1 py-2">
              反傾銷稅
            </div>
            <v-divider class="mb-2" />
            <div
              class="red--text pb-2"
            >
              屬於稽徵特別規定之商品，批量進口應課徵反傾銷稅並G1正式報關。
            </div>
          </template>
          <template v-if="!hasCcLimit">
            <div class="subTitle flex-grow-1 py-2">
              進口限制
            </div>
            <v-divider class="mb-2" />
            <div
              class="green--text pb-2"
            >
              該商品無進口限制
            </div>
            <div
              v-if="isFurniture"
              class="red--text pb-2"
            >
              家具務必使用漳州倉
            </div>
          </template>
        </div>
      </template>
    </div>
    <v-card v-else-if="hasSearchResults">
      <v-card-text>
        選擇一個最相似的商品：
        <div style="max-height: 440px;overflow-y: auto;overflow-x: hidden;">
          <v-layout
            wrap
            class="mt-2 mx-0"
          >
            <template
              v-for="item in searchGoodsList"
            >
              <v-flex
                v-if="!choseItemid || choseItemid === item.id"
                :key="item.id"
                xs6
                class="searchGoodsItem pa-1"
                @click="viewItem(item)"
              >
                <div class="itemContent">
                  <KImg
                    :src="getItemImage(item)"
                    replaceTbOrigin
                  />
                  <div
                    class="line-clamp-2 caption mt-1"
                    style="height: 3em;"
                  >
                    {{ getItemTitle(item) }}
                  </div>
                  <!-- <div class="choseBtn">
                    <v-icon
                      v-if="choseItemid === item.id"
                      class="blue--text">check_circle</v-icon>
                    <v-icon v-else>radio_button_unchecked</v-icon>
                  </div> -->
                </div>
              </v-flex>
            </template>
          </v-layout>
        </div>
      </v-card-text>
    </v-card>
    <div
      v-else-if="searchLoading"
      class="text-xs-center py-2"
    >
      資料讀取中……{{ searchTimer }}
    </div>
  </v-card>
</template>
<script>
// import { fetchGoods } from '@/utils/crxSDK'
import productSearchMixin from '@g/mixins/productSearchMixin'
import CanpackGoodsItem from '../../TpttCart/CanpackGoodsItem.vue'

export default {
  components: {
    CanpackGoodsItem,
  },
  mixins: [productSearchMixin],
  data () {
    return {
      // 商品查看相關
      loadingTpCat: false,
      tpCatError: '',
      taobaoData: null,
      answer: '',
      searchTimer: 0,
    }
  },
  computed: {
    tpCatalog () {
      if (this.taobaoData) {
        return this.taobaoData.catalog || this.taobaoData.tpCatalog
      }
      return null
    },
    firstQa () {
      if (this.tpCatalog && this.tpCatalog.catalogQas.length) {
        return this.tpCatalog.catalogQas[0]
      }
      return null
    },
    isFurniture () {
      return this.tpCatalog && (this.tpCatalog.catMold === '4' || this.tpCatalog.catMold === '45')
    },
    shangjian () {
      return this.$store.state.edition === 's' && this.tpCatalog.trfImportRule && this.tpCatalog.trfImportRule.indexOf('C02') > -1
    },
    huowushui () {
      return this.$store.state.edition === 's' && this.tpCatalog.trfLevyRule && this.tpCatalog.trfLevyRule.indexOf('T') > -1
    },
    fqxs () {
      return this.$store.state.edition === 's' && this.tpCatalog.trfAntiDumpingTax === '1'
    },
    hasCcBan () { // 禁止進品
      return this.tpCatalog.catCcMaxBox === '0' || this.tpCatalog.catCcMaxQty === '0' || this.tpCatalog.catCcMaxWt === '0'
    },
    hasCcLimit () { // 進品限制
      const tpCatalog = this.tpCatalog
      return tpCatalog.catCcMaxWt !== '999999' ||
      tpCatalog.catCcMaxBox !== '999' ||
      tpCatalog.catCcMaxQty !== '999999' ||
      tpCatalog.catMold === '2' ||
      tpCatalog.catMold === '3' ||
      tpCatalog.catShptBrief ||
      tpCatalog.shangjian ||
      tpCatalog.huowushui ||
      tpCatalog.fqxs
    },
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    async searchByKeyword (keyword = null) {
      const searchKey = keyword || this.searchKey

      // 檢查是否是鏈接或淘口令
      if (/https?:\/\/.+/.test(searchKey) || /\$.+\$/.test(searchKey)) {
        await this.handleUrlOrTaoCommand(searchKey)
        return
      }

      // 使用統一搜索服務
      await this.$options.mixins[0].methods.searchByKeyword.call(this, searchKey)
    },

    // 處理URL或淘口令搜索
    async handleUrlOrTaoCommand (searchKey) {
      try {
        this.searchLoading = true

        if (/\$.+\$/.test(searchKey)) {
          this.tpCatError = '淘口令請使用巧巧郎APP'
          return
        }

        // 使用统一服务获取商品详情
        const data = await this.searchService.fetchItemByUrl(searchKey)

        // 判断是1688还是淘宝商品
        if (data.catalog || data.tpCatalog) {
          // 淘宝商品，直接设置数据
          this.taobaoData = data
        } else if (data.item) {
          // 1688商品，调用viewItem继续处理
          return this.viewItem(data.item)
        }
      } catch (error) {
        if (error.code === 'UNKNOWN_CATEGORY') {
          this.tpCatError = error.message
        } else {
          this.tpCatError = error.message || '商品解析失敗'
        }
      } finally {
        this.searchLoading = false
      }
    },

    async viewItem (item) {
      let tiemr
      try {
        this.loadingTpCat = true

        this.searchTimer = 15
        tiemr = setInterval(() => {
          this.searchTimer--
          if (this.searchTimer < 1) {
            clearInterval(tiemr)
          }
        }, 1000)

        // 使用mixin的toggleItem方法确保tbdg-search商品的cid被正确查询
        if (!item.itemCid && item.searchSource === 'tbdg-search') {
          await this.$options.mixins[0].methods.toggleItem.call(this, item)
          console.log('this.choseItem', this.choseItem, item)
          item = this.choseItem || item
          if (!item.itemCid) {
            this.tpCatError = '該商品無法查詢，請更換商品試試'
            this.choseItem = null
            return
          }
        }

        const params = {
          item: {
            itemid: item.itemid || item.id,
            itemName: item.itemName || item.title,
            itemCid: item.itemCid || item.category,
            itemCidName: item.itemCidName || item.categoryName,
            itemFinalPrice: item.itemFinalPrice || item.price,
            itemPic: item.itemPic || item.pic_url || item.imageUrls[0],
            sellerId: item.traSellerId || item.sellerId,
            sellerNick: item.traSellerName || item.seller,
          }
        }

        const res = await this.$store.dispatch('tpsp/tpttItem/viewTaobao', {
          params,
          options: {
            noShowError: true,
            retry: 0,
          }
        })
        if (!res.data.error) {
          if (!res.data.model.catalog.catTwName) {
            this.tpCatError = {
              name: 'unknownCat',
              message: `巧巧郎不知道「${this.searchKey}」是什麽，<br/>需要查一下資料，請您10分鐘之後再來問我好嗎？<br/>這段時間您可以先查詢其他商品喔～`
            }
            return
          }
          this.taobaoData = res.data.model
        } else {
          this.tpCatError = res.data.msg || '商品查詢失敗'
        }
      } finally {
        this.loadingTpCat = false
        clearInterval(tiemr)
      }
    },
    // 重寫 mixin 中的重置方法，添加額外的重置邏輯
    resetSearch () {
      // 調用 mixin 的重置方法
      this.$options.mixins[0].methods.resetSearch.call(this)

      // 額外的重置邏輯
      this.taobaoData = null
      this.tpCatError = ''
      this.answer = ''
    },
    submitAnswer () {
      const answerData = this.firstQa[this.answer]
      if (this.firstQa.qaType === 'pt') {
        this.tpCatalog.catSrType = answerData.catSrType
      } else if (this.firstQa.qaType === 'ar') {
        this.tpCatalog.catEmbargoAir = answerData.catEmbargoAir
      } else if (this.firstQa.qaType === 'se') {
        this.tpCatalog.catEmbargoSe = answerData.catEmbargoSe
      } else if (this.firstQa.qaType === 'cc') {
        this.tpCatalog.catCcMaxBox = answerData.catCcMaxBox
        this.tpCatalog.catCcMaxQty = answerData.catCcMaxQty
        this.tpCatalog.catShptBrief = answerData.brief
        this.tpCatalog.catCcMethod = answerData.catCcMethod || this.tpCatalog.catCcMethod
        this.tpCatalog.catCcMaxWt = answerData.catCcMaxWt || this.tpCatalog.catCcMaxWt
        this.tpCatalog.catInclTaxMaxWt = answerData.catInclTaxMaxWt || this.tpCatalog.catCcMaxWt
        this.tpCatalog.catMold = answerData.catMold || this.tpCatalog.catMold
      } else if (this.firstQa.qaType === 'cm') {
        this.tpCatalog.catMold = answerData.catMold
      }
      this.tpCatalog.catalogQas.splice(0, 1)
      this.answer = ''
    },
  }
}
</script>
<style lang="postcss" scoped>
.searchGoodsItem {
  &:nth-child(2n+1){
    padding-right: 5px;
  }
  &:nth-child(2n){
    padding-left: 5px;
  }
  img {
    width: 100%;
  }
  .itemContent {
    border: 1px dashed rgba(0,0,0,0.2);
    border-radius: 5px;
    padding: 3px;
    position: relative;
    .choseBtn {
      position: absolute;
      left: 0px;
      top: 0px;
      background: #fff;
    }
  }
}
</style>
